import React, { Component } from 'react';
import { themr } from 'react-css-themr';
import { translate } from 'react-i18next';
import compose from 'recompose/compose';
import theme from './TeamSelectorFilter.scss';
import { withRouter } from 'common/components/core/router';
import { connect } from 'react-redux';
import SalesCategoriesActions from 'common/redux/actions/salesCategories';
import { AsyncMultiSelectFilter } from 'common/components/core/select';
import { getSalesCategories } from 'common/redux/selectors/salesCategories';
import { clientSelector } from 'common/redux/selectors/queryParamsSelectors';
import FilterListBuilder from 'common/models/helpers/FilterListBuilder';
import { FilterBuilder, FilterOperation } from 'common/models/internal/Filter';
import { debounce } from 'lodash';

const defaultActiveFilter = new FilterListBuilder()
    .add(
        new FilterBuilder()
            .withName('status')
            .withOperation(FilterOperation.Equals)
            .withValue('ACTIVE')
    )
    .build();

const selectSalesCategoryId = option => option.id;
const selectSalesCategoryName = option => option.name;

class SalesCategoryFilter extends Component {
    static defaultProps = {
        getOptionLabel: selectSalesCategoryName
    };
    constructor(props) {
        super(props);
        this.debouncedFetch = debounce(this.fetchFilteredsSalesCategories, 300);
    }

    componentWillUnmount() {
        this.debouncedFetch.cancel();
    }

    fetchFilteredsSalesCategories = filters => {
        const { clientId, fetchSalesCategories } = this.props;
        const body = { filters: defaultActiveFilter };
        if (filters) {
            body.filters = [...defaultActiveFilter, ...filters];
        }
        fetchSalesCategories({ clientId }, body);
    };

    render() {
        const { salesCategory, filterOptionsBasedOn, ...rest } = this.props;
        const options = salesCategory ? salesCategory.toArray() : [];
        return (
            <AsyncMultiSelectFilter
                {...rest}
                options={options}
                getOptionValue={selectSalesCategoryId}
                fetchFilteredOptions={this.debouncedFetch}
                filterOptionsBasedOn={filterOptionsBasedOn || 'name'}
            />
        );
    }
}

const ThemedSalesCategoryFilter = compose(
    themr('TeamFilter', theme),
    translate()
)(SalesCategoryFilter);

const mapStateToProps = (state, ownProps) => {
    const salesCategory = getSalesCategories(state, ownProps);
    const clientId = clientSelector(state, ownProps);
    return {
        salesCategory,
        clientId
    };
};

const ConnectedSalesCategoryFilter = withRouter(
    connect(mapStateToProps, {
        fetchSalesCategories: SalesCategoriesActions.fetchSalesCategories
    })(ThemedSalesCategoryFilter)
);

const ConnectedSalesCategoryIdFilter = props => (
    <ConnectedSalesCategoryFilter
        {...props}
        getOptionLabel={selectSalesCategoryId}
        filterOptionsBasedOn="id"
    />
);

export default ThemedSalesCategoryFilter;
export { ConnectedSalesCategoryFilter, ConnectedSalesCategoryIdFilter };
